function csrfSafeMethod(method) {
	// these HTTP methods do not require CSRF protection
	return /^(GET|HEAD|OPTIONS|TRACE)$/i.test(method);
}

function beforeSend(xhr, settings) {
    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        var csrftoken = Array.apply(0, Array(16)).map(() => (Math.random()*36|0).toString(36)).join('');
        document.cookie = 'csrftoken=' + csrftoken + '; path=/';
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
}

$.ajaxSetup({
    beforeSend: function(xhr, settings) {
        beforeSend.call(this, xhr, settings);
    }
});

export function showLoadingScreen() {
    var tmpt = `<div id="ajax-loading" class="ajax-loading"><div><div><img src="/static/images/ajax-loader.gif"><br>Please wait...<div></div></div>`;
    var el = $('#ajax-loading');
    if (!el.length) {
        el = $(tmpt).appendTo($('body'))
    }
    el.show();
}

export function hideLoadingScreen() {
    $('#ajax-loading').hide();
}

export function postJSON (url, data) {
    return $.ajax({
        type: "POST",
        url: url,
        contentType: 'application/json',
        data: JSON.stringify(data),
        processData: false,
        beforeSend:function(xhr, settings){
            beforeSend.call(this, xhr, settings);
            showLoadingScreen();
        },
        complete: function(data){
            hideLoadingScreen();
        }
    });
}

$.getFormData = function ($form) {
    var obj = {};

    $form.serializeArray().forEach(function(n, i){
        obj[n['name']] = n['value'];
    });

    return obj;
}

$(function() {
    // hide caret in the search input in IE up to version 11.
    $('.navbar-r input').on('mouseleave', e => e.currentTarget.blur());

    // menu animation
    $('.ie8 .navbar-main .dropdown.categories, .ie9 .navbar-main .dropdown.categories').hover(
        e => $('.dropdown-menu', e.currentTarget).slideDown(300),
        e => $('.dropdown-menu', e.currentTarget).hide()
    );

    // navigation in mobile
    $(document).on('touchstart', e => {
        if (!$(e.target).closest('.dropdown.categories').length) {
            $('.navbar-main .dropdown.categories').removeClass('active');
        }
    });
    $('.navbar-main .dropdown.categories').on('touchstart', e => {
        if (!$(e.target).is('.categories >a') || !$('.dropdown-menu', e.currentTarget).length) return;
        e.preventDefault();
        $('.navbar-main .dropdown.categories').removeClass('active');
        $(e.currentTarget).addClass('active')
    });
});
